export default "__VITE_ASSET__HSv88dGf__"